import React, { useMemo, useState } from 'react';
import { FolderCard } from '../FolderCard';
import { MediaCard } from '../MediaCard';
import styled from 'styled-components';
import { IMediaItem } from 'modules/media/interfaces/api';
import { MediaPreviewModal } from '../MediaPreviewModal';
import { Box, Col, Text } from 'basic-ui-lib';

const MediaManagerGridModeV2 = ({
  items,
  onOpenFolder,
  currentPath,
  onSuccess,
  storeId,
}: {
  items: IMediaItem[];
  onOpenFolder: (folder: IMediaItem) => void;
  currentPath: string;
  onSuccess: (currentPath: string) => void;
  storeId?: string;
}) => {
  const [previewIndex, setPreviewIndex] = useState<number | null>(null);
  const mediaItems = items.filter((i) => i.type !== 'FOLDER');

  const handlePreview = (id: string) => {
    setPreviewIndex(mediaItems.findIndex((i) => i.id === id));
  };

  const folders = useMemo(
    () => items.filter((i) => i.type === 'FOLDER'),
    [items],
  );

  const media = useMemo(
    () => items.filter((i) => i.type !== 'FOLDER'),
    [items],
  );
  return (
    <>
      <Container>
        {folders.length > 0 && (
          <Col gap={16}>
            <Text semibold content_2 left>Folders ({folders.length})</Text>
            <Box className='media-list'>
              {folders.map((item) => (
                <FolderCard
                  key={item.id}
                  item={item}
                  onClick={() => onOpenFolder(item)}
                  length={item.children?.length || 0}
                  currentPath={currentPath}
                  onSuccess={onSuccess}
                  storeId={storeId}
                />
              ))}
            </Box>
          </Col>
        )}
        {media.length > 0 && (
          <Col gap={16}>
            <Text semibold content_2 left>Media ({media.length})</Text>
            <Box className='media-list'>
              {media.map((item) => (
                <MediaCard
                  key={item.id}
                  item={item}
                  onClick={() => handlePreview(item.id)}
                  currentPath={currentPath}
                  onSuccess={onSuccess}
                  storeId={storeId}
                />
              ))}
            </Box>
          </Col>
        )}
      </Container>
      {previewIndex !== null && (
        <MediaPreviewModal
          items={mediaItems}
          initialIndex={previewIndex}
          onClose={() => setPreviewIndex(null)}
          setPreviewIndex={setPreviewIndex}
        />
      )}
    </>
  );
};

export default MediaManagerGridModeV2;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .folder-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .media-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
  }
`;
